import React, { FC, createContext, useState } from 'react'

type VideoOverlayContextProps = {
    onStartHover?: (gifId: string) => void
    onFinishHover?: (gifId: string) => void
    onFinishVolumeIconAnimation?: () => void
    finishVolumeIconAnimation?: boolean
    hoveredClip?: string | null
}

type Props = {}

export const VideoContext = createContext({} as VideoOverlayContextProps)

const VideoContextManager: FC<Props> = ({ children }) => {
    const [hoveredClip, setHoveredClip] = useState<null | string>(null)
    const [finishVolumeIconAnimation, setFinishVolumeIconAnimation] = useState(false)

    return (
        <VideoContext.Provider
            value={{
                onStartHover: (gifId: string) => setHoveredClip(gifId),
                onFinishHover: () => setHoveredClip(null),
                onFinishVolumeIconAnimation: () => setFinishVolumeIconAnimation(true),
                finishVolumeIconAnimation,
                hoveredClip,
            }}
        >
            {children}
        </VideoContext.Provider>
    )
}

export default VideoContextManager
